import { Tooltip } from "antd";
import React from "react";

const CustomToolTip = ({ children, title, placement = "bottom" }) => {
    return (
        <Tooltip overlayStyle={{ zIndex: '90' }} overlayClassName="custom-tooltip poppins-font-family" title={title} placement={placement as any}>
            {children}
        </Tooltip>
    )
};

export default CustomToolTip;